export const WORKSPACE_TAB_CHANGE_EVENT = "stuspace:tab-change";
